export default "__VITE_ASSET__Cr0wkmlp__"